import React, { useState, useEffect } from "react";

const ToggleSwitch = ({ checked, onChange }) => (
  <div className={`toggle-switch ${checked ? "active" : ""}`} onClick={() => onChange(!checked)}>
    <div className="toggle-switch-slider"></div>
  </div>
);

const ContentSettings = ({ settings, onUpdate }) => {
  const [localSettings, setLocalSettings] = useState(settings || {});

  useEffect(() => {
    setLocalSettings(settings || {});
  }, [settings]);

  const handleUpdate = async (key, value) => {
    const updated = { ...localSettings, [key]: value };
    setLocalSettings(updated);
    try {
      await onUpdate(updated);
    } catch (error) {
      setLocalSettings(localSettings);
    }
  };

  return (
    <div>
      <div className="settings-header">
        <h1>Conteúdo</h1>
        <p>Controle como o conteúdo é exibido e consumido</p>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">🎬 Qualidade de Vídeo</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Qualidade padrão</div>
          </div>
          <div className="settings-item-control">
            <select
              className="settings-select"
              value={localSettings.videoQuality || "auto"}
              onChange={(e) => handleUpdate("videoQuality", e.target.value)}
            >
              <option value="auto">Automático</option>
              <option value="low">Baixa</option>
              <option value="medium">Média</option>
              <option value="high">Alta</option>
              <option value="hd">HD</option>
            </select>
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Modo economia de dados</div>
            <div className="settings-item-description">
              Reduz a qualidade para economizar dados móveis
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.dataSavingMode === true}
              onChange={(val) => handleUpdate("dataSavingMode", val)}
            />
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">📥 Download Automático</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Download via Wi-Fi</div>
            <div className="settings-item-description">
              Baixar mídia automaticamente quando conectado ao Wi-Fi
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.autoDownloadMedia?.wifi !== false}
              onChange={(val) =>
                handleUpdate("autoDownloadMedia", {
                  ...localSettings.autoDownloadMedia,
                  wifi: val,
                })
              }
            />
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Download via dados móveis</div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.autoDownloadMedia?.cellular === true}
              onChange={(val) =>
                handleUpdate("autoDownloadMedia", {
                  ...localSettings.autoDownloadMedia,
                  cellular: val,
                })
              }
            />
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">🔞 Filtros de Conteúdo</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Filtro de conteúdo explícito</div>
            <div className="settings-item-description">
              Ocultar conteúdo sensível ou impróprio
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.explicitContentFilter !== false}
              onChange={(val) => handleUpdate("explicitContentFilter", val)}
            />
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Ocultar conteúdo reportado</div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.hideReported !== false}
              onChange={(val) => handleUpdate("hideReported", val)}
            />
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3 className="settings-section-title">💡 Sugestões e Anúncios</h3>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Mostrar posts sugeridos</div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.showSuggestedPosts !== false}
              onChange={(val) => handleUpdate("showSuggestedPosts", val)}
            />
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Mostrar anúncios</div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.showAds !== false}
              onChange={(val) => handleUpdate("showAds", val)}
            />
          </div>
        </div>

        <div className="settings-item">
          <div className="settings-item-info">
            <div className="settings-item-label">Anúncios personalizados</div>
            <div className="settings-item-description">
              Usar suas informações para anúncios mais relevantes
            </div>
          </div>
          <div className="settings-item-control">
            <ToggleSwitch
              checked={localSettings.personalizedAds === true}
              onChange={(val) => handleUpdate("personalizedAds", val)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentSettings;
